<template>
  <div style="width: 72px">
    <a-progress :showInfo="false" :percent="percent" :strokeColor="color" />
  </div>
</template>

<script>
export default {
  name: 'BillProgress',
  props: {
    percentage: {
      type: Number,
      required: true,
    },
    colors: {
      type: Array,
      required: true,
    },
    ranges: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {}
  },
  computed: {
    color () {
      for (let i = 0; i < this.ranges.length; i++) {
        if (i === 0 && this.percentage <= this.ranges[0]) {
          return this.colors[0]
        } else if (i === this.ranges.length - 1 && this.percentage > this.ranges[this.ranges.length - 1]) {
          return this.colors[i + 1]
        } else if (this.percentage > this.ranges[i - 1] && this.percentage <= this.ranges[i]) {
          return this.colors[i]
        }
      }
      return 'red'
    },
    percent () {
      return isNaN(this.percentage) ? 0 : this.percentage
    },
  },
}
</script>
